const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/Buttons/IconMore.tsx';
import { Icon } from '@mui/material';
import * as React from 'react';
import { css, cx } from '@emotion/css';
import { useTheme } from '@mui/material/styles';
import { useMemo } from 'react';

const iconStyle = css`
    display: flex;
    align-self: center;
    margin-top: 6px;
`;

function useCSSClasses() {
    const theme = useTheme();
    return useMemo(
        () => ({
            muiIconNoHover: css`
                color: ${theme.palette.secondary.main};
            `,
        }),
        [theme]
    );
}

export const IconMore = () => {
    const classes = useCSSClasses();
    return (
        <div className={iconStyle}>
            <div>
                {/* component = "span" fixed a react warning : react_devtools_backend.js:2430 Warning: validateDOMNesting(...): <button> cannot appear as a descendant of <button>*/}
                <Icon className={cx('icons8-chevron-right', classes.muiIconNoHover)} component="span" />
            </div>
        </div>
    );
};
